define('config/application',[
    'has'
], function(has) {
    'use strict';

    return {
        title: 'Florex Trader',
        appId: 'florex',
        controllerSuffix: '',
        locale: 'en',
        apiKey: '2cfcf8c0-0566-4b3c-b9b0-4810b3b2b82c',
        environment: has('production') ? 'production' : 'development',
        locales: [
            { name: 'en', title: 'English' },
            { name: 'ru', title: 'Russian' }
        ],
        themes: [
            //{ name: 'blue', title: 'Синяя' }
        ]
    };
});
